





























import { defineComponent } from '@nuxtjs/composition-api';
import { TypeBody, TypeDisplay } from '@bambeehr/pollen';
import BaseCard from '@/components/BaseCard/BaseCard.vue';
import { contactUsContent } from '@/content/contactUs/contactUs';

// Billing freeze (BIO-2036): delete this component once checkout is back.
export default defineComponent({
  name: 'BillingFreezeNotice',
  components: {
    BaseCard,
    TypeBody,
    TypeDisplay,
  },
  props: {
    title: {
      type: String,
      default: 'Online checkout isn’t available right now',
    },
    // Renders without the full-page background and card, for use inside a
    // modal or an existing page section.
    inline: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const email = 'support@bambee.com';
    const phone = contactUsContent.customerSupportPhoneNumber;

    return {
      email,
      phone,
      emailHref: `mailto:${email}`,
      phoneHref: `tel:${phone.replace(/\D/g, '')}`,
    };
  },
});
